/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkPlaceDTO
 */
export interface WorkPlaceDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkPlaceDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkPlaceDTO
     */
    place?: string;
}

/**
 * Check if a given object implements the WorkPlaceDTO interface.
 */
export function instanceOfWorkPlaceDTO(value: object): value is WorkPlaceDTO {
    return true;
}

export function WorkPlaceDTOFromJSON(json: any): WorkPlaceDTO {
    return WorkPlaceDTOFromJSONTyped(json, false);
}

export function WorkPlaceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPlaceDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'place': json['place'] == null ? undefined : json['place'],
    };
}

export function WorkPlaceDTOToJSON(json: any): WorkPlaceDTO {
    return WorkPlaceDTOToJSONTyped(json, false);
}

export function WorkPlaceDTOToJSONTyped(value?: WorkPlaceDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'place': value['place'],
    };
}


